module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deleteLicense"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('h2', [_vm._v("Delete License")]), _vm._v(" "), _c('el-form', {
    ref: "LicenseForm",
    attrs: {
      "label-position": "left",
      "model": _vm.LicenseForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Project Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.LicenseForm.project),
      callback: function($$v) {
        _vm.$set(_vm.LicenseForm, "project", $$v)
      },
      expression: "LicenseForm.project"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Direct Customer"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.LicenseForm.direct_cus),
      callback: function($$v) {
        _vm.$set(_vm.LicenseForm, "direct_cus", $$v)
      },
      expression: "LicenseForm.direct_cus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "label": "Expiry Date"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.checked),
      expression: "!checked"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "Select Date",
      "value-format": "timestamp"
    },
    model: {
      value: (_vm.LicenseForm.exp_date),
      callback: function($$v) {
        _vm.$set(_vm.LicenseForm, "exp_date", $$v)
      },
      expression: "LicenseForm.exp_date"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("No Limit")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Customer Email"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "type": "email",
      "placeholder": "Email Address",
      "clearable": ""
    },
    model: {
      value: (_vm.LicenseForm.user_email),
      callback: function($$v) {
        _vm.$set(_vm.LicenseForm, "user_email", $$v)
      },
      expression: "LicenseForm.user_email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "ER Number"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "ER Number",
      "clearable": ""
    },
    model: {
      value: (_vm.LicenseForm.er_num),
      callback: function($$v) {
        _vm.$set(_vm.LicenseForm, "er_num", $$v)
      },
      expression: "LicenseForm.er_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "NE Point"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "NE Point",
      "type": "textarea",
      "clearable": ""
    },
    model: {
      value: (_vm.LicenseForm.ne_point),
      callback: function($$v) {
        _vm.$set(_vm.LicenseForm, "ne_point", $$v)
      },
      expression: "LicenseForm.ne_point"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('router-link', {
    attrs: {
      "to": "search"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "plain": ""
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.deleting
    },
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v("Confirm to Delete")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189e93ec","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeleteLicense.vue
// module id = h2tU
// module chunks = 1